import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useSearchOption = () => {
  const { state, pathname } = useLocation();

  const [lastSearchForm, setLastSearchForm] = useState();
  const [lastSearchPageable, setLastSearchPageable] = useState();

  useEffect(() => {
    setLastSearchForm(state?.searchOption?.lastSearchForm);
    setLastSearchPageable(state?.searchOption?.lastSearchPageable);
  }, [state]);

  const searchOptionState = useMemo(() => {
    const searchOption = {};
    if (lastSearchForm && lastSearchPageable) {
      searchOption.url = pathname;
      searchOption.lastSearchForm = { ...lastSearchForm };
      searchOption.lastSearchPageable = { ...lastSearchPageable };
    }

    return { state: { searchOption } };
  }, [lastSearchForm, lastSearchPageable, pathname]);

  return {
    searchOptionState,
  };
};

export default useSearchOption;
